import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white p-4">
      <img src="/PhytoBot_Original.png" alt="Phytobiotics" className="w-80 h-auto mb-6" />
      <h1 className="text-2xl font-semibold mb-4">404 - Page not found</h1>
      <p className="text-gray-600 mb-6">Sorry, the page you are looking for does not exist.</p>
      <button
        onClick={() => navigate('/')}
        
        className="px-6 py-2 bg-zinc-600 text-white rounded hover:bg-zinc-700 cursor-pointer"
      >
        Back to home
      </button>
    </div>
  );
};

export default NotFoundPage;
